import type { GA4AnalyticsEvent } from '@/domain/shared/types'
import { buildImgSrc } from '@/helpers/image-url'
import { LazyImage } from '@/scopes/common/components/Image'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { space, tokPx } from '@sunwebgroup/ui-components'
import { useState } from 'react'
import { styled } from 'styled-components'
import { Detail } from './Detail'

const Wrapper = styled.div`
  position: relative;
`

const ImagesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  height: 100%;
`

const ImageWrapper = styled.button`
  overflow: hidden;
  align-content: center;
  margin-right: ${space('primitives_space_8')};
  margin-bottom: ${space('primitives_space_8')};
  width: 90px;
  height: 90px;
  img {
    position: relative;
    filter: unset;
  }
  @media (min-width: ${tokPx('primitives_breakpoint_m_min')}) {
    flex: unset;
  }
`
interface GalleryProps {
  name: string
  images: string[]
  analyticsEventBuilder: (index: number, name: string) => GA4AnalyticsEvent
}

export function Gallery({ name, images, analyticsEventBuilder }: GalleryProps) {
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [showDetail, setShowDetail] = useState(false)

  const { sendEvent } = useAnalytics()

  const handleImageClick = (index: number) => {
    setShowDetail(true)
    setSelectedIndex(index)
    sendEvent(analyticsEventBuilder(index, name))
  }

  const closeDetail = () => {
    setShowDetail(false)
  }

  return (
    <Wrapper>
      <ImagesContainer>
        {images.map((image, index) => (
          <ImageWrapper key={index} onClick={() => handleImageClick(index)}>
            <LazyImage
              src={buildImgSrc(image, 480, 270) || ''}
              srcSet={[480, 240]}
              alt={name || ''}
            />
          </ImageWrapper>
        ))}
      </ImagesContainer>
      {images?.length > 0 && (
        <Detail
          onClose={closeDetail}
          open={showDetail}
          startFromIndex={selectedIndex}
          roomtypeLabel={name}
          roomtypeImages={images}
        />
      )}
    </Wrapper>
  )
}
